import {useState, useEffect} from 'react';

export const useFetch = (options) => {
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState();
    const [errorMessage, setErrorMessage] = useState();
    
    useEffect(() => {
        if(!options.url) return;
        if(!options.requestOptions) return;

        setIsLoading(true);
        
        // fake fetch the data
        // const delayFetch = (url, requestOptions) => new Promise((resolve) => {setTimeout(() => {resolve(fetch(url, requestOptions));}, 3000);});

        async function fetchData() {
                // const response = await delayFetch(options.url, options.requestOptions);
                const response = await fetch(options.url, options.requestOptions);
                const result = await response.json();
                setData(result);
        }

        try {
            fetchData();
            setIsLoading(false);
            if(data.errorMessage) setErrorMessage(data.errorMessage);
        } catch(e) {
            setIsLoading(false);
        }

    }, [options.url]);

    return {data, isLoading, errorMessage}
}